/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BvcHVwLW1vZGFscy9zaG93LXVwZGF0ZWQtcGFzc3dvcmQtcG9wdXAvc2hvdy11cGRhdGVkLXBhc3N3b3JkLXBvcHVwLmNvbXBvbmVudC5zY3NzIn0= */"];
export { styles as styles };
